import type { ImportResult } from '@integratio/core';
import { ConfirmationPanel } from '../components/ConfirmationPanel';
import { DataQualityWarnings } from '../components/DataQualityWarnings';
import { FileValidationSummary } from '../components/FileValidationSummary';
import { ImportedDataTable } from '../components/ImportedDataTable';

interface Props {
  result: ImportResult;
  onConfirm: () => void;
  onCancel: () => void;
  busy: boolean;
  error: string | null;
}

export function ReviewScreen({ result, onConfirm, onCancel, busy, error }: Props): JSX.Element {
  return (
    <div className="mx-auto max-w-[1400px] space-y-6 px-6 py-10">
      <header>
        <p className="eyebrow">Etapa 2</p>
        <h1 className="mt-1 text-3xl font-semibold tracking-tight text-brand-ink">Conferência dos dados importados</h1>
        <p className="mt-2 max-w-3xl text-sm text-brand-slate">
          Revise os registros lidos da planilha. Nenhum gráfico é gerado antes da sua confirmação.
        </p>
      </header>

      <FileValidationSummary result={result} />
      <DataQualityWarnings warnings={result.warnings} />
      <ImportedDataTable result={result} />

      {error && (
        <p role="alert" className="rounded-xl border border-brand-red/30 bg-brand-red/5 px-4 py-3 text-sm text-brand-redDark">
          {error}
        </p>
      )}

      <ConfirmationPanel
        totalStakeholders={result.stakeholders.length}
        warningsCount={result.warnings.length}
        canProceed={result.canProceed}
        onConfirm={onConfirm}
        onCancel={onCancel}
        busy={busy}
      />
    </div>
  );
}
